import {Injectable, Inject} from 'ng-metadata/core';

@Injectable()
export class AlertBarService {
    
    private messagesDismissed: Object;
    
    constructor() {
        this.messagesDismissed = {};
    }


    public messageShouldDisplay(key,value){
        if(!this.messagesDismissed[key]) {
            this.messagesDismissed[key] = false;
        }

        if(value){
            this.messagesDismissed[key] = value;
        }

        return !this.messagesDismissed[key];

    }

}
//put here all angular1 modules the service is using
export default [];



// WEBPACK FOOTER //
// ./src/main/webapp/components/infra/widgets/alerts/alertBar.service.ts